module.exports = __webpack_public_path__ + "media/man8.bb532d00.wav";